module.exports = __webpack_public_path__ + "static/img/f3.0148a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/f3.png
// module id = c7mD
// module chunks = 1